import {toast} from 'react-toastify';

import {
    AUTH_ERROR,
    AUTH_SIGNIN_REQUEST,
    AUTH_SIGNIN_SUCCESS,
    AUTH_SIGNOUT_REQUEST,
    AUTH_SIGNOUT_SUCCESS,
    AUTH_UPDATE_PASSWORD_REQUEST,
    AUTH_UPDATE_PASSWORD_SUCCESS, AUTH_USER_MIGRATED
} from '../types';

import {
  API_SIGNIN,
  API_SIGNOUT,
  API_UPDATE_PASSWORD
} from '../../configs/apis';

import {apiFetch, parseApiResponse} from '../../apiFetch';

export function emailSignIn(values) {
  return async (dispatch) => {
    dispatch({type: AUTH_SIGNIN_REQUEST});
    try {
      const {access_token: token} = await apiFetch(API_SIGNIN, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'post',
        body: JSON.stringify(values)
      });

      dispatch({type: AUTH_SIGNIN_SUCCESS, token});

    } catch ({error}) {
      if (error === "inactive"){
          dispatch({type: AUTH_USER_MIGRATED});
      } else {
          toast.error(error);
          dispatch({type: AUTH_ERROR});
      }
    }
  };
}

export function signOut(values) {
  return async (dispatch) => {
    dispatch({type: AUTH_SIGNOUT_REQUEST});
    try {
      await apiFetch(API_SIGNOUT, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'delete',
        body: JSON.stringify(values)
      });

      dispatch({type: AUTH_SIGNOUT_SUCCESS});

    } catch (error) {
      toast.error(error);
      dispatch({type: AUTH_ERROR});
    }
  };
}

export function updatePassword(values) {
  return async (dispatch) => {
    dispatch({type: AUTH_UPDATE_PASSWORD_REQUEST});
    try {
      await apiFetch(API_UPDATE_PASSWORD, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'put',
        body: JSON.stringify(values)
      });

      dispatch({type: AUTH_UPDATE_PASSWORD_SUCCESS});

      toast.success('Your password was updated');
      return true

    } catch ({errors}) {
      dispatch({type: AUTH_ERROR, errors});
      return false
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/auth/index.js